class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback();

    if (!this.els?.slide?.exists) return;

    this.carousel = this.setupCarousel();

    if (!this.els?.thumbnails?.exists) return;
    this.thumbnailCarousel = this.setupThumbnailCarousel();
  }

  setupListeners () {
    super.setupListeners();

    if (!this.els?.thumbnails?.exists) return;

    this.handleThumbnailTrigger = this.handleThumbnailTrigger.bind(this);

    this.els.thumbnailtrigger.elements.forEach(thumbnailtriggerEl => {
      this.listeners.add(
        thumbnailtriggerEl,
        'click',
        this.handleThumbnailTrigger,
      );
    });
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this);

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        slideChanged: this.onSlideChanged,
      },
      [
        window.BAO.Carousel.plugins.setInitialised(),
        window.BAO.Carousel.plugins.useArrows({
          next: this.els?.slidesNext?.element,
          previous: this.els?.slidesPrevious?.element,
        }),
      ]
    );
  }

  onSlideChanged (instance) {
    if (!this.els?.thumbnails?.exists) return;

    const currentSlide = instance.track.details.rel;

    // Update the aria-current attribute for the active thumbnail
    this.els.thumbnail.elements.forEach((thumbnail, index) => {
      thumbnail.setAttribute('aria-current', index === currentSlide);
    });

    // Ensure the active thumbnail is in view within the thumbnail carousel
    this.updateThumbnailCarousel(currentSlide);
  }

  setupThumbnailCarousel () {
    return new window.KeenSlider(
      this.els.thumbnails.element,
      {
        selector: this.els.thumbnail.selector,
        loop: false,
        mode: 'snap',
        slides: {
          spacing: 7,
          perView: 4, // Show 4 thumbnails at a time
        },
        vertical: false,
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 'auto',
              spacing: 20,
            },
            vertical: true,
          },
        },
      },
      [
        window.BAO.Carousel.plugins.setInitialised(),
        window.BAO.Carousel.plugins.useArrows({
          next: this.els?.thumbnailNext?.element,
          previous: this.els?.thumbnailPrevious?.element,
        }),
      ]
    );
  }

  handleThumbnailTrigger (e) {
    const thumbnailTrigger = e.target.closest(
      `${this.els.thumbnailtrigger.selector}`
    );

    const targetIndex = parseInt(thumbnailTrigger.dataset.index, 10);

    // Move to the target index in the main carousel
    this.carousel.moveToIdx(targetIndex);

    // Ensure the clicked thumbnail is within the visible range
    this.updateThumbnailCarousel(targetIndex);
  }

  updateThumbnailCarousel (activeIndex) {
    const maxVisibleThumbnails = 4;

    // Calculate the starting index to center the active thumbnail if possible
    let startIndex = Math.max(0, Math.min(activeIndex - Math.floor(maxVisibleThumbnails / 2), this.els.thumbnail.elements.length - maxVisibleThumbnails));

    // Move the thumbnail carousel to show the thumbnails starting from startIndex
    this.thumbnailCarousel.moveToIdx(startIndex);
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia);
}